<template>
  <div>
    <b-form-group :label="trans('program')" class="mb-3">
      <b-form-select
        v-model="program_id"
        v-on:change="onProgramChange()"
        :options="programs"
        :disabled="busy"
      />
    </b-form-group>
    
    <b-form-group :label="trans('activity')" class="mb-3">
      <treeselect
        id="treeselect"
        :multiple="false"
        openDirection="below"
        :options="treeOptions"
        :disable-branch-nodes="true"
        :default-expand-level="2"
        :placeholder="treeTitle"
        :disabled="busy"
        v-model="activity_id"
      >
      </treeselect>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    props: {
      organization: Object,
      allPrograms: Array,
    },
    components: {
      Treeselect,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        program_id: null,
        programs: [
          {value: null, text: trans('select_a_program')},
        ],
        treeOptions: [],
        activity_id: null,
        activities: null,
      }
    },
    computed: {
      treeTitle() {
        return !this.busy ? trans('select_activity') : trans('please_wait')
      },
      activity() {
        if (!this.activity_id) return null
        return _.find(this.activities || [], {id: this.activity_id}) || null
      },
    },
    watch: {
      program_id() {
        this.$emit('program-id', this.program_id)
      },
      activity_id() {
        this.$emit('activity-id', this.activity_id)
        this.$emit('activity', this.activity)
      },
    },
    methods: {
      loadPrograms() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/amilia/programs`
        return axios.get(url)
        .then(response => {
          this.busy = false
          // Build the programs
          let hidden = []
          response.data.forEach(item => {
            let option = {
              value: item.id,
              text: item.name
            }
            if (item.visible)
              this.programs.push(option)
            else
              hidden.push(option)
          })
          if (hidden.length > 0) {
            this.programs.push({
              value: null,
              text: trans('visible_only_administrators'),
              disabled: true
            })
            hidden.forEach(option => {
              this.programs.push(option)
            })
          }
          this.$emit('all-programs', this.programs)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onProgramChange(no) {
        this.loadActivities()
      },
      loadActivities() {
        this.busy = true
        this.error = null
        this.treeSelection = null
        let url = `/organization/${this.organization.id}/amilia/programs/${this.program_id}/activities?show_more=true&hide_occurrences=true`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.activities = response.data
          // Build the treeview
          let tree = {}
          this.activities.forEach(function(a) {
            if (!tree[a.category_id])
              tree[a.category_id] = {
                id: 'c' + a.category_id,
                label: a.category_name,
                isDefaultExpanded: true,
                children: {}
              }
            if (!tree[a.category_id].children[a.subcategory_id])
              tree[a.category_id].children[a.subcategory_id] = {
                id: 's' + a.subcategory_id,
                label: a.subcategory_name,
                children: []
              }
            let name = a.name
            if (a.is_hidden) name += ` (${trans('hidden').toLowerCase()})`
            if (a.is_cancelled) name += ` (${trans('cancelled').toLowerCase()})`
            tree[a.category_id].children[a.subcategory_id].children.push({
              id: a.id,
              label: name,
            })
          })
          tree = _.values(tree)
          tree.forEach(function(node) {
            node.children = _.values(node.children)
          })
          this.treeOptions = tree
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.chooseAmiliaActivity = this
      if (this.allPrograms) {
        this.programs = this.allPrograms
      } else {
        this.loadPrograms()
      }
    },
  }
</script>